'use client';

import FilterAwareVisibilityToggle from '../FilterAwareVisibilityToggle/FilterAwareVisibilityToggle';
import { ProductTileConfigType } from 'node_modules/@nxt-costco-com/forge-digital-components/dist/components/Product/ProductTile/types';

import { type ReactElement, useState } from 'react';

import { VideoSpotlightClient } from '@/components/SearchResultsFacets/VideoSpotlightClient';
import { NO_RESULTS_CONTAINER_ID } from '@/src/app/[lang]/(customers)/s/constants';
import { SearchResultsGrid } from '@/src/components/SearchResultsGrid';
import { ProductTileConfigType as LocalProductTileConfigType } from '@/src/components/SearchResultsGrid/types';
import { SearchResultsPagination } from '@/src/components/SearchResultsPagination';
import SearchVisibilityToggle from '@/src/containers/main/SearchVisibilityToggle';
import { PRODUCT_DISPLAY_STYLE } from '@/src/containers/main/constants';
import {
    ComposerData,
    SearchConfig,
    SearchPageConfigProperties,
    SponsoredProductPlacementConfig,
} from '@/types/contentStack';
import { PageType } from '@/types/pages/search';
import { Box } from '@mui/material';
import { Divider } from '@nxt-costco-com/forge-components';
import type {
    ContentStackEntryDataProps,
    LocaleProps,
} from '@nxt-costco-com/forge-digital-components';

export function SearchResultRegion({
    site,
    lang,
    composerData,
    pageConfig,
    fullRowAdEntries,
    productTileConfigData,
    searchConfigData,
    displayRegion = true,
    isCategoryPage,
    pageType,
    categoryTitle,
    showMultiVariantsAvailability,
    resultsPerPage,
    clpAdPlacementFallbackSettings,
}: {
    site: string;
    lang: LocaleProps;
    composerData?: ComposerData;
    pageConfig: ContentStackEntryDataProps<SearchPageConfigProperties>;
    fullRowAdEntries?: ReactElement[];
    productTileConfigData: ProductTileConfigType;
    searchConfigData?: SearchConfig;
    displayRegion?: boolean;
    isCategoryPage?: boolean;
    pageType: PageType;
    categoryTitle?: string;
    showMultiVariantsAvailability: boolean;
    resultsPerPage: number;
    clpAdPlacementFallbackSettings?: SponsoredProductPlacementConfig[];
}) {
    // Counter and handler to increment when a pagination event happens.
    const [doFocusFirstItem, setDoFocusFirstItem] = useState(0);
    const handleFocus = () => {
        setDoFocusFirstItem(prev => {
            return prev + 1;
        });
    };

    return (
        <SearchVisibilityToggle
            enabled={displayRegion}
            fallback={<Box id={NO_RESULTS_CONTAINER_ID} />}
        >
            <FilterAwareVisibilityToggle region={'AboveGrid'}>
                <VideoSpotlightClient
                    lang={lang}
                    position={'grid'}
                    pageType={pageType}
                    // @ts-expect-error Components has fallback to default props for all other props
                    product_display_style={
                        productTileConfigData?.translationsConfig
                            ?.product_display_style ?? PRODUCT_DISPLAY_STYLE
                    }
                />
            </FilterAwareVisibilityToggle>
            <SearchResultsGrid
                pageConfig={pageConfig}
                site={site}
                lang={lang}
                productTileConfigData={
                    productTileConfigData as LocalProductTileConfigType
                }
                composerData={composerData}
                searchConfigData={searchConfigData}
                fullRowAdEntries={fullRowAdEntries}
                isCategoryPage={isCategoryPage}
                pageType={pageType}
                categoryTitle={categoryTitle}
                doFocusFirstItem={doFocusFirstItem}
                showMultiVariantsAvailability={showMultiVariantsAvailability}
                resultsPerPage={resultsPerPage}
                clpAdPlacementFallbackSettings={clpAdPlacementFallbackSettings}
            />

            <SearchResultsPagination
                pageConfig={pageConfig}
                handleFocus={handleFocus}
            />
            <Divider sx={{ margin: '10px 0 20px' }} />
        </SearchVisibilityToggle>
    );
}
